/* Maison Lamora — 2.5D installation composer.
   Port of the iOS app's CompositionEngine: lays out N hand-blown pieces for a
   composition, then renders them on a canvas with wires, depth sorting, orbit
   and the real piece photographs (sprites) from Content → Files.

   var c = new LamoraComposer(canvas, config);  c.set({...}); c.render();
   config: { design, pieces, width, depth, height, scale, dropStart, dropEnd,
             sprites: [sku,...], colors: [hex,...], spots, yaw, pitch, background } */
(function () {
  var TAU = Math.PI * 2;

  function rand(i, s) {
    var x = Math.sin(i * 127.1 + s * 311.7) * 43758.5453;
    return x - Math.floor(x);
  }

  function catmull(pts, t) {
    var segs = pts.length - 1;
    var seg = Math.min(Math.floor(t * segs), segs - 1);
    var lt = t * segs - seg;
    var p0 = pts[Math.max(0, seg - 1)], p1 = pts[seg], p2 = pts[Math.min(pts.length - 1, seg + 1)], p3 = pts[Math.min(pts.length - 1, seg + 2)];
    function f(a, b, c, d) { var t2 = lt * lt, t3 = t2 * lt; return 0.5 * ((2 * b) + (-a + c) * lt + (2 * a - 5 * b + 4 * c - d) * t2 + (-a + 3 * b - 3 * c + d) * t3); }
    return [f(p0[0], p1[0], p2[0], p3[0]), f(p0[1], p1[1], p2[1], p3[1]), f(p0[2], p1[2], p2[2], p3[2])];
  }

  /* positions(design, n, W, D) -> [{x, z, f, tangent}] ; units = cm */
  function positions(design, n, W, D, topR, botR) {
    var P = [];
    if (n <= 0) return P;
    topR = topR == null ? 1 : topR; botR = botR == null ? 0.72 : botR;
    function grid(profile) {
      var cols = Math.max(1, Math.round(Math.sqrt(n * W / Math.max(D, 1))));
      var rows = Math.ceil(n / cols), idx = 0;
      for (var r = 0; r < rows; r++) for (var c = 0; c < cols; c++) {
        if (idx >= n) return;
        var tx = cols === 1 ? 0.5 : c / (cols - 1), tz = rows === 1 ? 0.5 : r / (rows - 1);
        P.push({ x: (tx - 0.5) * W, z: (tz - 0.5) * D, f: profile(tx, tz, idx) });
        idx++;
      }
    }
    switch (design) {
      case 'grid': grid(function () { return 0.5; }); break;
      case 'randomheights': grid(function (a, b, i) { return rand(i, 61); }); break;
      case 'ucurve': grid(function (tx) { return 0.24 + 0.72 * Math.sin(Math.PI * tx); }); break;
      case 'vcurve': grid(function (tx) { return 0.26 + 0.72 * (1 - Math.abs(tx - 0.5) * 2); }); break;
      case 'ring': {
        var bands = 3, per = Math.ceil(n / bands), idx = 0;
        for (var b = 0; b < bands && idx < n; b++) {
          var inset = b * 0.11, w = W * (1 - inset), d = D * (1 - inset);
          var cnt = Math.min(per, n - idx), perim = 2 * (w + d);
          for (var i = 0; i < cnt; i++) {
            var dist = (cnt === 1 ? 0 : i / cnt) * perim, x, z;
            if (dist < w) { x = -w / 2 + dist; z = -d / 2; }
            else if (dist < w + d) { x = w / 2; z = -d / 2 + (dist - w); }
            else if (dist < 2 * w + d) { x = w / 2 - (dist - w - d); z = d / 2; }
            else { x = -w / 2; z = d / 2 - (dist - 2 * w - d); }
            P.push({ x: x, z: z, f: 0.5 + (rand(idx, 7) - 0.5) * 0.12 });
            idx++;
          }
        }
        break;
      }
      case 'cascadespiral': {
        var R = Math.min(W, D) * 0.44, turns = Math.max(2, n / 10), total = TAU * turns;
        for (var k = 0; k < n; k++) {
          var t = n <= 1 ? 0.5 : k / (n - 1), a = t * total, r = R * (topR * (1 - t) + botR * t);
          P.push({ x: Math.cos(a) * r, z: Math.sin(a) * r, f: t, tangent: a + Math.PI / 2 });
        }
        break;
      }
      case 'waterfall': {
        var ax = -W * 0.32, az = -D * 0.18, bx = W * 0.32, bz = -D * 0.18, cz = D * 0.38;
        for (var m = 0; m < n; m++) {
          var side = m % 2 === 0, sx = side ? ax : bx, sz = side ? az : bz;
          var bt = Math.pow(rand(m, 41), 0.65);
          P.push({ x: sx * (1 - bt) + (rand(m, 42) - 0.5) * W * 0.05, z: sz * (1 - bt) + cz * bt, f: 0.15 + 0.8 * bt });
        }
        break;
      }
      case 'ribbon': {
        var pts = [[0, 0, 0], [W * 0.28, -W * 0.14, D * 0.22], [-W * 0.22, -W * 0.30, D * 0.5], [W * 0.18, -W * 0.46, D * 0.78], [0, -W * 0.62, D]];
        for (var q = 0; q < n; q++) {
          var p = catmull(pts, n === 1 ? 0 : q / (n - 1));
          P.push({ x: p[0], z: p[2] - D / 2, f: p[1] < 0 ? Math.min(1, -p[1] / (W * 0.62)) : 0 });
        }
        break;
      }
      default: { // flock
        var cx = -W * 0.28;
        for (var j = 0; j < n; j++) {
          var bias = Math.pow(rand(j, 31), 2.1);
          P.push({ x: cx + bias * W * 0.95, z: (rand(j, 32) - 0.5) * D * 0.85, f: 0.12 + 0.85 * rand(j, 33) });
        }
      }
    }
    return P;
  }

  /* A quiet room that turns with the view: warm wall wash, a lit corner and a floor. */
  function drawEnvironment(ctx, cw, ch, yaw) {
    var t = (Math.sin(yaw) + 1) / 2;            // 0..1 as the view turns
    var horizon = ch * 0.78;
    var wall = ctx.createLinearGradient(0, 0, 0, horizon);
    wall.addColorStop(0, '#171410');
    wall.addColorStop(0.55, '#221d16');
    wall.addColorStop(1, '#2b251c');
    ctx.fillStyle = wall; ctx.fillRect(0, 0, cw, horizon);

    var lightX = cw * (0.18 + 0.64 * t);
    var pool = ctx.createRadialGradient(lightX, ch * 0.28, 0, lightX, ch * 0.28, Math.max(cw, ch) * 0.7);
    pool.addColorStop(0, 'rgba(255,224,170,.16)');
    pool.addColorStop(0.45, 'rgba(255,214,150,.05)');
    pool.addColorStop(1, 'rgba(255,214,150,0)');
    ctx.fillStyle = pool; ctx.fillRect(0, 0, cw, ch);

    var floor = ctx.createLinearGradient(0, horizon, 0, ch);
    floor.addColorStop(0, '#2a241b');
    floor.addColorStop(1, '#100e0a');
    ctx.fillStyle = floor; ctx.fillRect(0, horizon, cw, ch - horizon);
    ctx.fillStyle = 'rgba(255,228,180,.05)';
    ctx.beginPath(); ctx.ellipse(lightX, horizon + (ch - horizon) * 0.5, cw * 0.32, (ch - horizon) * 0.7, 0, 0, TAU); ctx.fill();

    var vig = ctx.createRadialGradient(cw / 2, ch * 0.45, Math.min(cw, ch) * 0.25, cw / 2, ch * 0.5, Math.max(cw, ch) * 0.75);
    vig.addColorStop(0, 'rgba(0,0,0,0)');
    vig.addColorStop(1, 'rgba(0,0,0,.55)');
    ctx.fillStyle = vig; ctx.fillRect(0, 0, cw, ch);
  }

  /* spotPositions(n, spread, pattern, W, D) -> [{x, z}] in cm */
  function spotPositions(n, spread, pattern, W, D) {
    n = Math.max(1, n || 1);
    var out = [];
    if (pattern === 'circle') {
      var r = Math.min(W, D) * 0.55 * spread;
      for (var i = 0; i < n; i++) { var a = (i / n) * TAU; out.push({ x: Math.cos(a) * r, z: Math.sin(a) * r }); }
    } else if (pattern === 'square') {
      var side = Math.max(1, Math.ceil(Math.sqrt(n))), size = Math.min(W, D) * 1.1 * spread, idx = 0;
      for (var j = 0; j < side && idx < n; j++) for (var q = 0; q < side && idx < n; q++) {
        var tx = side === 1 ? 0.5 : q / (side - 1), tz = side === 1 ? 0.5 : j / (side - 1);
        out.push({ x: (tx - 0.5) * size, z: (tz - 0.5) * size }); idx++;
      }
    } else {
      var cols = Math.max(1, Math.round(Math.sqrt(n * W / Math.max(D, 1))));
      var rows = Math.max(1, Math.ceil(n / cols)), c2 = 0;
      for (var r2 = 0; r2 < rows && c2 < n; r2++) for (var q2 = 0; q2 < cols && c2 < n; q2++) {
        var ux = cols === 1 ? 0.5 : q2 / (cols - 1), uz = rows === 1 ? 0.5 : r2 / (rows - 1);
        out.push({ x: (ux - 0.5) * W * 1.05 * spread, z: (uz - 0.5) * D * 1.05 * spread }); c2++;
      }
    }
    return out;
  }

  /* ---------- sprite cache ---------- */
  var cache = {};
  function sprite(sku, onload) {
    if (!sku) return null;
    var c = cache[sku];
    if (c) return c;
    c = cache[sku] = { img: new Image(), ok: false, failed: false };
    c.img.crossOrigin = 'anonymous';
    c.img.onload = function () { c.ok = true; onload && onload(); };
    c.img.onerror = function () {
      if (!c.triedPng && window.LAMORA && LAMORA.fileUrl) { c.triedPng = true; c.img.src = LAMORA.fileUrl(sku + '-sprite.png'); return; }
      c.failed = true; onload && onload();
    };
    var url = window.LAMORA && LAMORA.pieceSprite ? LAMORA.pieceSprite(sku) : '';
    if (url) c.img.src = url; else c.failed = true;
    return c;
  }

  function hexToRgb(h) {
    h = (h || '#dba85a').replace('#', '');
    if (h.length === 3) h = h.split('').map(function (c) { return c + c; }).join('');
    var n = parseInt(h, 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  }

  /* drawn glass fallback when a sprite is missing */
  function drawGlass(ctx, x, y, w, h, color, rot) {
    var rgb = hexToRgb(color);
    ctx.save();
    ctx.translate(x, y);
    ctx.rotate(rot);
    var g = ctx.createLinearGradient(-w / 2, 0, w / 2, h);
    g.addColorStop(0, 'rgba(255,255,255,.85)');
    g.addColorStop(0.35, 'rgba(' + rgb.join(',') + ',.75)');
    g.addColorStop(1, 'rgba(' + rgb.map(function (v) { return Math.round(v * 0.55); }).join(',') + ',.85)');
    ctx.fillStyle = g;
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.bezierCurveTo(w * 0.7, h * 0.25, w * 0.45, h * 0.8, 0, h);
    ctx.bezierCurveTo(-w * 0.45, h * 0.8, -w * 0.7, h * 0.25, 0, 0);
    ctx.fill();
    ctx.strokeStyle = 'rgba(255,255,255,.35)';
    ctx.lineWidth = 0.8;
    ctx.stroke();
    ctx.restore();
  }

  function Composer(canvas, cfg) {
    this.canvas = canvas;
    this.ctx = canvas.getContext('2d');
    this.cfg = Object.assign({
      design: 'randomheights', pieces: 34, width: 180, depth: 80, height: 110,
      scale: 100, dropStart: 15, dropEnd: 95, sprites: [], colors: ['#dba85a'],
      spots: true, spotPattern: 'rectangle', spotCount: 18, spotColor: 'white', spotSpread: 100,
      pieceRotate: 0, pieceJitter: 100,
      yaw: -0.5, pitch: 0.32, pieceCm: 22, background: null, ceiling: true, environment: true
    }, cfg || {});
    this._raf = null;
  }

  Composer.positions = positions;

  Composer.prototype.set = function (patch) {
    Object.assign(this.cfg, patch);
    this.render();
  };

  Composer.prototype.render = function () {
    var self = this;
    if (this._raf) return;
    this._raf = requestAnimationFrame(function () { self._raf = null; self.draw(self.canvas, self.ctx); });
  };

  /* Draws into ctx sized (cw, ch). Returns scale info. */
  Composer.prototype.draw = function (canvas, ctx, opts) {
    opts = opts || {};
    var c = this.cfg;
    var dpr = opts.dpr || Math.min(window.devicePixelRatio || 1, 2);
    var cw = opts.width || canvas.clientWidth || 800, ch = opts.height || canvas.clientHeight || 600;
    if (!opts.width) {
      if (canvas.width !== Math.round(cw * dpr) || canvas.height !== Math.round(ch * dpr)) {
        canvas.width = Math.round(cw * dpr); canvas.height = Math.round(ch * dpr);
      }
    }
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.clearRect(0, 0, cw, ch);
    if (c.background) { ctx.fillStyle = c.background; ctx.fillRect(0, 0, cw, ch); }
    if (c.environment && opts.environment !== false) drawEnvironment(ctx, cw, ch, c.yaw);

    var W = c.width, D = c.depth, H = c.height;
    var pts = positions(c.design, Math.round(c.pieces), W, D, c.spiralTop, c.spiralBottom);
    var cy = Math.cos(c.yaw), sy = Math.sin(c.yaw), cp = Math.cos(c.pitch), sp = Math.sin(c.pitch);
    var ds = c.dropStart / 100, de = c.dropEnd / 100;
    var pieceH = c.pieceCm * c.scale / 100;
    var cascade = c.design === 'cascadespiral' || c.design === 'waterfall' || c.design === 'ribbon';

    function project(x, y, z) {
      var rx = x * cy - z * sy, rz = x * sy + z * cy;
      return { x: rx, y: y * cp + rz * sp, depth: rz * cp - y * sp };
    }

    // world items
    var items = pts.map(function (p, i) {
      var drop = cascade ? (ds + (de - ds) * p.f) * H : (ds + (de - ds) * p.f) * H;
      var top = project(p.x, 0, p.z);
      var pos = project(p.x, drop, p.z);
      return { i: i, top: top, pos: pos, depth: pos.depth, p: p, drop: drop };
    });

    // bounds (include ceiling footprint and piece height)
    var minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
    var ext = Math.max(W, D) * 0.55;
    [[-ext, -ext], [ext, -ext], [ext, ext], [-ext, ext]].forEach(function (q) {
      var pr = project(q[0], 0, q[1]);
      minX = Math.min(minX, pr.x); maxX = Math.max(maxX, pr.x); minY = Math.min(minY, pr.y); maxY = Math.max(maxY, pr.y);
    });
    items.forEach(function (it) {
      minX = Math.min(minX, it.pos.x - pieceH * 0.5); maxX = Math.max(maxX, it.pos.x + pieceH * 0.5);
      maxY = Math.max(maxY, it.pos.y + pieceH * 1.1);
    });
    var pad = opts.pad == null ? 0.08 : opts.pad;
    var bw = maxX - minX, bh = maxY - minY;
    var k = Math.min(cw * (1 - pad * 2) / bw, ch * (1 - pad * 2) / bh);
    if (opts.fixedScale) k = opts.fixedScale;
    var ox = cw / 2 - (minX + bw / 2) * k;
    var oy = opts.topAlign ? ch * pad - minY * k : ch / 2 - (minY + bh / 2) * k;
    function sx(v) { return ox + v * k; }
    function syy(v) { return oy + v * k; }

    // ceiling plane
    if (c.ceiling !== false) {
      ctx.save();
      var corners = [[-ext, -ext], [ext, -ext], [ext, ext], [-ext, ext]].map(function (q) { return project(q[0], 0, q[1]); });
      ctx.beginPath();
      corners.forEach(function (q, n) { n ? ctx.lineTo(sx(q.x), syy(q.y)) : ctx.moveTo(sx(q.x), syy(q.y)); });
      ctx.closePath();
      ctx.fillStyle = opts.ceilingFill || 'rgba(255,240,215,0.035)';
      ctx.fill();
      ctx.strokeStyle = opts.ceilingStroke || 'rgba(255,240,215,0.08)';
      ctx.lineWidth = 1;
      ctx.stroke();
      ctx.restore();
    }

    // ceiling spotlights — pattern, count and finish are chosen in the configurator
    if (c.spots) {
      var spots = spotPositions(Math.round(c.spotCount), (c.spotSpread || 100) / 100, c.spotPattern, W, D);
      var FIN = {
        white: { ring: 'rgba(238,236,230,.95)', inner: '#fffaf0', glow: 'rgba(255,244,222,' },
        black: { ring: 'rgba(38,35,30,.95)', inner: '#151310', glow: 'rgba(255,232,190,' },
        gold:  { ring: 'rgba(206,164,96,.95)', inner: '#f2dcae', glow: 'rgba(255,224,160,' }
      }[c.spotColor] || { ring: 'rgba(238,236,230,.95)', inner: '#fffaf0', glow: 'rgba(255,244,222,' };
      spots.forEach(function (sp) {
        var p = project(sp.x, 0, sp.z);
        var gx = sx(p.x), gy = syy(p.y);
        var near = 0.75 + 0.25 * (1 - (p.depth - 0) / Math.max(W, 1));
        var rr = Math.max(1.8, 3.2 * k / 3.2) * near;
        var glow = ctx.createRadialGradient(gx, gy, 0, gx, gy, rr * 3.2);
        glow.addColorStop(0, FIN.glow + '.4)');
        glow.addColorStop(1, FIN.glow + '0)');
        ctx.fillStyle = glow; ctx.beginPath(); ctx.arc(gx, gy, rr * 3.2, 0, TAU); ctx.fill();
        ctx.beginPath(); ctx.ellipse(gx, gy, rr, rr * 0.45, 0, 0, TAU);
        ctx.fillStyle = FIN.ring; ctx.fill();
        ctx.beginPath(); ctx.ellipse(gx, gy, rr * 0.55, rr * 0.25, 0, 0, TAU);
        ctx.fillStyle = FIN.inner; ctx.fill();
      });
    }

    // wires
    ctx.save();
    ctx.strokeStyle = opts.wireColor || 'rgba(232,220,196,0.5)';
    ctx.lineWidth = Math.max(0.9, 1.1 * dpr / 2);
    ctx.beginPath();
    items.forEach(function (it) { ctx.moveTo(sx(it.top.x), syy(it.top.y)); ctx.lineTo(sx(it.pos.x), syy(it.pos.y)); });
    ctx.stroke();
    ctx.strokeStyle = opts.wireHighlight || 'rgba(255,240,210,0.22)';
    ctx.lineWidth = Math.max(1.8, 2.2 * dpr / 2);
    ctx.stroke();
    ctx.restore();

    // pieces, far to near
    items.sort(function (a, b) { return b.depth - a.depth; });
    var sprites = c.sprites && c.sprites.length ? c.sprites : [null];
    var colors = c.colors && c.colors.length ? c.colors : ['#dba85a'];
    var self = this;
    var minD = Infinity, maxD = -Infinity;
    items.forEach(function (it) { minD = Math.min(minD, it.depth); maxD = Math.max(maxD, it.depth); });
    items.forEach(function (it) {
      var idx = it.i % sprites.length;
      var sp = sprite(sprites[idx], function () { self.render(); });
      var near = maxD === minD ? 1 : 1 - (it.depth - minD) / (maxD - minD);
      var alpha = 0.72 + 0.28 * near;
      var hpx = pieceH * k * (0.9 + 0.2 * near) * (0.85 + rand(it.i, 5) * 0.3);
      var baseRot = (c.pieceRotate || 0) * Math.PI / 180;
      var jit = (c.pieceJitter == null ? 100 : c.pieceJitter) / 100;
      var rot = baseRot + (rand(it.i, 9) - 0.5) * 0.5 * jit + (it.p.tangent != null ? Math.sin(it.p.tangent + c.yaw) * 0.25 : 0);
      var x = sx(it.pos.x), y = syy(it.pos.y);
      ctx.globalAlpha = alpha;
      if (sp && sp.ok) {
        var img = sp.img, ar = img.naturalWidth / img.naturalHeight;
        var h = hpx, w = h * ar;
        if (ar > 1.4) { w = hpx * 1.2; h = w / ar; }
        ctx.save();
        ctx.translate(x, y);
        ctx.rotate(rot);
        if (rand(it.i, 13) > 0.5) ctx.scale(-1, 1);
        ctx.shadowColor = 'rgba(0,0,0,.45)';
        ctx.shadowBlur = Math.max(3, hpx * 0.12);
        ctx.shadowOffsetY = hpx * 0.03;
        ctx.drawImage(img, -w / 2, 0, w, h);
        ctx.shadowColor = 'transparent';
        // warm light catching the top of the piece
        ctx.globalCompositeOperation = 'lighter';
        var kiss = ctx.createRadialGradient(-w * 0.12, h * 0.22, 0, -w * 0.12, h * 0.22, w * 0.75);
        kiss.addColorStop(0, 'rgba(255,238,206,' + (0.18 * near + 0.06) + ')');
        kiss.addColorStop(1, 'rgba(255,238,206,0)');
        ctx.fillStyle = kiss;
        ctx.beginPath(); ctx.ellipse(-w * 0.12, h * 0.3, w * 0.5, h * 0.42, 0, 0, TAU); ctx.fill();
        ctx.globalCompositeOperation = 'source-over';
        ctx.restore();
      } else {
        drawGlass(ctx, x, y, hpx * 0.45, hpx, colors[it.i % colors.length], rot);
      }
      ctx.globalAlpha = 1;
    });

    this.lastScale = k; // px per cm at this render
    return { pxPerCm: k, width: cw, height: ch, contentWidth: bw * k };
  };

  /* Offscreen transparent render for the room viewer. */
  Composer.prototype.snapshot = function (w, h) {
    var off = document.createElement('canvas');
    off.width = w; off.height = h;
    var ctx = off.getContext('2d');
    var saved = { background: this.cfg.background, ceiling: this.cfg.ceiling, spots: this.cfg.spots, environment: this.cfg.environment };
    this.cfg.background = null; this.cfg.ceiling = false; this.cfg.environment = false;
    var info = this.draw(off, ctx, { width: w, height: h, dpr: 1, pad: 0.02, topAlign: true, environment: false, wireColor: 'rgba(55,50,42,0.6)', wireHighlight: 'rgba(255,255,255,0.18)' });
    Object.assign(this.cfg, saved);
    info.canvas = off;
    return info;
  };

  /* Orbit by dragging */
  Composer.prototype.enableOrbit = function (el) {
    var self = this, start = null;
    function pt(e) { var t = e.touches ? e.touches[0] : e; return { x: t.clientX, y: t.clientY }; }
    el.addEventListener('pointerdown', function (e) { start = { p: pt(e), yaw: self.cfg.yaw, pitch: self.cfg.pitch }; self.autoRotate(false); el.setPointerCapture(e.pointerId); });
    el.addEventListener('pointermove', function (e) {
      if (!start) return;
      var p = pt(e);
      self.cfg.yaw = start.yaw + (p.x - start.p.x) * 0.008;
      self.cfg.pitch = Math.max(0.05, Math.min(0.95, start.pitch + (p.y - start.p.y) * 0.004));
      self.render();
    });
    el.addEventListener('pointerup', function () { start = null; });
    el.addEventListener('pointercancel', function () { start = null; });
  };

  Composer.prototype.autoRotate = function (on) {
    var self = this;
    if (this._spin) { cancelAnimationFrame(this._spin); this._spin = null; }
    if (!on || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
    var last = performance.now();
    function tick(now) {
      self.cfg.yaw += (now - last) * 0.00012; last = now;
      self.draw(self.canvas, self.ctx);
      self._spin = requestAnimationFrame(tick);
    }
    this._spin = requestAnimationFrame(tick);
  };

  window.LamoraComposer = Composer;
})();
